import styled from 'styled-components';
import { FONT_SIZE, COLORS, BORDER_RADIUS, MEDIA_QUERIES } from '../Variables';

export const PetitionPage = styled.section`
  margin: 0 auto;
  max-width: ${(props) => props.maxWidth};
  h1 {
    text-align: center;
    margin: 30px auto;
    font-size: ${FONT_SIZE.h1};
    line-height: 120%;
    color: ${COLORS.fontColor};
    width: ${(props) => props.fullTitle === 'full' && '950px'}
  }
  .petition_content {
    display: flex;
    justify-content: ${(props) => props.content};
    .left_side {
      display: flex;
      flex-direction: column;
      flex-basis: 66%;
      .petition_image {
        img {
          width: 95%;
          height: 300px;
          object-fit: cover;
          aspect-ratio: auto;
        }
      }
      .author {
        display: flex;
        margin: 15px 0;
        img,
        svg {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          object-fit: contain;
        }
        span {
          align-self: center;
          margin-left: 10px;
          font-size: ${FONT_SIZE.small};
          color: ${COLORS.darkGrey};
          line-height: 1.4;
          font-weight: 700;
          a {
            color: ${COLORS.darkGrey};
          }
        }
      }
      p {
        font-size: ${FONT_SIZE.default};
        color: ${COLORS.fontColor};
        line-height: 1.5;
        padding: 0 30px 0 0;
        overflow-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
        margin: initial;
        padding: initial;
        a {
          word-wrap: break-word;
          overflow-wrap: break-word;
          word-break: break-word;
          hyphens: auto;
          span {
            font-size: ${FONT_SIZE.small};
          }
        }
        ul,
        ol {
          padding: 0 0 0 30px;
          margin: 1.5em 0;
        }
      }
    }
    .right_side {
      display: flex;
      flex-direction: column;
      flex-basis: 33%;
      .right_side_title {
        span {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 5px;
          p:nth-child(1) {
            font-weight: 900;
          }
          p {
            line-height: 1.4;
            font-size: ${FONT_SIZE.petition_title};
          }
        }
      }
    }
  }
`;

export const MobilePetitionPage = styled.section`
  h1 {
    margin: 60px 0 30px;
    text-align: center;
    @media ${MEDIA_QUERIES.MOBILE} {
      text-align: left;
      margin: 15px 0 30px 5px;
      padding: 0 5px;
    }
  }
  img {
    width: 100%;
    max-height: 374px;
    object-fit: cover;
    @media ${MEDIA_QUERIES.MOBILE} {
      width: 95%;
      position: relative;
      left: 2.5%;
    }
  }
  .mobile_counter {
    display: flex;
    gap: 5px;
    margin: 10px 0 15px 15px;
    font-size: ${FONT_SIZE.medium};
    color: ${COLORS.fontColor};
    font-weight: 700;
  }
  .author {
    display: flex;
    gap: 5px;
    margin: 15px 0;
    padding: 0 0 0 5px;
    img,
    svg {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
    span {
      align-self: center;
      font-size: ${FONT_SIZE.small};
      font-weight: 700;
      color: ${COLORS.darkGrey};
      a {
        color: ${COLORS.darkGrey};
      }
    }
  }
  .mobile_petition_content {
    padding: 0 10px;
    line-height: 1.4;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
    a {
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      hyphens: auto;
    }
    ul,
    ol {
      padding: 0 0 0 30px;
      margin: 1.5em 0;
    }
  }
`;
export const MobileSignButtonContainer = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 70px;
  background-color: ${COLORS.footerColor};
  position: sticky;
  bottom: 0;
  left: 0;
  margin: 15px 0 0;
  button {
    align-self: center;
    height: 80%;
    width: 95%;
    padding: 8px 22px;
    border-radius: ${BORDER_RADIUS};
    outline: none;
    color: ${COLORS.white};
    font-size: ${FONT_SIZE.default};
    letter-spacing: 1px;
    font-weight: 700;
    border: none;
  }
  .yesOnPopupReminder {
    border: 1px solid
      ${(props) =>
        props.lang === 'hazteoir' ? `${COLORS.hoOrange}` : `${COLORS.cgoBlue}`};
    animation: yesOnPopupReminderAnimation 1s 3;
  }
  @keyframes yesOnPopupReminderAnimation {
    50% {
      transform: scale(1.03);
    }
    100% {
      transform: scale(1);
    }
  }
`;
export const LetterDesktopPetitionPage = styled.section`
  display: flex;
  flex-direction: column;
  width: 80%;
  gap: 15px;
  margin: 0 auto;
  border-top: 1px solid ${COLORS.greyColor};
  .letter_title {
    display: flex;
    justify-content: center;
    margin-top: 17px;
    text-align: center;
    font-weight: 700;
    color: ${COLORS.fontColor};
  }
  .letter_content {
    p {
      /* display: flex;
      flex-direction: column;
      justify-content: center; */
      color: ${COLORS.darkGrey};
      font-size: ${FONT_SIZE.default};
      text-align: left;
      line-height: 1.4;
      font-style: italic;
      font-weight: 400;
      text-decoration: none;
      * {
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        /* hyphens: auto; */
        color: ${COLORS.darkGrey};
        font-size: ${FONT_SIZE.default};
        text-align: left;
        line-height: 1.4;
        font-style: italic;
      }
    }
    ul,
    ol {
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      hyphens: auto;
      color: ${COLORS.darkGrey};
      font-size: ${FONT_SIZE.default};
      text-align: left;
      line-height: 1.4;
      font-style: italic;
      padding: 0 0 0 30px;
      margin: 1.5em 0;
    }
  }
`;
export const LetterMobilePetitionPage = styled.section`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 50px auto;
  border: 1px solid ${COLORS.greyColor};
  border-radius: ${BORDER_RADIUS};
  padding: 15px 65px;
  @media ${MEDIA_QUERIES.MOBILE} {
    width: 95%;
    padding: 15px 30px;
  }
  .letter_title {
    display: flex;
    justify-content: center;
    color: ${COLORS.fontColor};
    font-size: ${FONT_SIZE.default};
    text-align: center;
    font-weight: 700;
    margin: 30px 0;
  }
  .letter_content {
    * {
      font-size: ${FONT_SIZE.default};
      font-weight: 400;
      color: ${COLORS.darkGrey};
      line-height: 1.4;
      text-align: left;
      font-style: italic;
      text-decoration: none;
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      hyphens: auto;
    }
    ul,
    ol {
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      hyphens: auto;
      color: ${COLORS.darkGrey};
      font-size: ${FONT_SIZE.default};
      text-align: left;
      line-height: 1.4;
      font-style: italic;
      padding: 0 0 0 30px;
      margin: 1.5em 0;
    }
  }
`;
export const FormContainerPetitionPage = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 80%;
  padding: 25px 0 50px;
  margin: 0 auto;
  background-color: ${COLORS.white};
  @media ${MEDIA_QUERIES.TABLET} {
    padding: 20px 0;
  }
  .yesOnPopupReminder {
    border: 1px solid
      ${(props) =>
        props.lang === 'hazteoir' ? `${COLORS.hoOrange}` : `${COLORS.cgoBlue}`};
    animation: yesOnPopupReminderAnimation 1s 3;
  }
  @keyframes yesOnPopupReminderAnimation {
    50% {
      transform: scale(1.03);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const NoInGdprInfo = styled.div`
  border: 1px solid ${COLORS.red};
  border-radius: 4px;
  padding: 8px 12px;
  margin: 10px 0 20px;
  background-color: ${COLORS.footerColor};
  p {
    font-size: ${FONT_SIZE.medium};
    text-align: left;
    line-height: 1.4;
    color: ${COLORS.fontColor};
  }
`;

export const ButtonLoader = styled.div`
  position: relative;
  z-index: 1;
  top: 5px;
  left: 0;
  width: 100%;
  height: 5px;
  border-radius: ${BORDER_RADIUS};
  background: linear-gradient(-45deg, #ff7c00, #4281f0, #ff7c00);
  background-size: 200% 200%;
  animation: gradient 1s ease infinite;
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const PetitionLogoContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
`;
